export type OrderDialogMessages = {
  cancelOrderDialogTitle: string;
  cancelOrderDialogContent: string;
};

export const ORDER_DIALOG_MESSAGES: OrderDialogMessages = {
  cancelOrderDialogTitle: "Cancelar Pedido",
  cancelOrderDialogContent: "Você tem certeza que deseja cancelar este pedido?",
};
